export { default } from "./useTableRestQuery";
